"use client";

import { createContext, useContext, ReactNode } from "react";
import {
  useFeatureFlagsStore,
  SubscriptionLevel,
} from "@/services/feature-flags";

interface FeatureFlagContextType {
  subscriptionLevel: SubscriptionLevel;
  isDemoMode: boolean;
  setSubscriptionLevel: (level: SubscriptionLevel) => void;
  hasAccessToFeature: (feature: string) => boolean;
}

const FeatureFlagContext = createContext<FeatureFlagContextType | undefined>(
  undefined,
);

export function FeatureFlagProvider({ children }: { children: ReactNode }) {
  const {
    subscriptionLevel,
    isDemoMode,
    setSubscriptionLevel,
    hasAccessToFeature,
  } = useFeatureFlagsStore();

  const value = {
    subscriptionLevel,
    isDemoMode,
    setSubscriptionLevel,
    hasAccessToFeature,
  };

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
}

export function useFeatureFlags() {
  const context = useContext(FeatureFlagContext);
  if (context === undefined) {
    throw new Error(
      "useFeatureFlags must be used within a FeatureFlagProvider",
    );
  }
  return context;
}
